import { viduGetCost } from '@/app/services/vidu';

export type {
  MaterialsCancelElementTaskData,
  MaterialsCreateElementTaskData,
  MaterialsGetElementTaskStateData,
  MaterialsListElementTaskHistoryData,
} from '@/app/services/vidu';
export {
  materialsCancelElementTask,
  materialsCreateElementTask,
  materialsGetElementTaskState,
  materialsListElementTaskHistory,
} from '@/app/services/vidu';

export const getElementTaskCost = () =>
  viduGetCost({
    query: {
      biz_code: 'element_task',
    },
  });
